// @ts-nocheck
/**
 * lassoTransformControl.ts
 * 投げ縄変形・編集モード関連メソッド
 * App.vue から切り出し
 */

import {
  featureCollectionAdd,
  markerAddAndRemove,
  scaleAndRotateLassoSelected,
  saveDrowFeatures,
  pushMyDrawUndoAction,
  updateDragHandles,
  generateSegmentLabelGeoJSON,
  generateStartEndPointsFromGeoJSON,
  getAllVertexPoints,
  setAllMidpoints,
} from '@/js/downLoad'
import {
  hideTransformBox,
  refreshTransformBox,
} from '@/js/draw'

type VM = any

export async function persistAndExitEditMode(vm: VM, restorePrev) {
  const map01 = vm.$store.state.map01;
  const wasEditEnabled = vm.$store.state.editEnabled;
  const prevGeojson = vm.$store.state.prevGeojson; // 編集前の状態を保持
  try {
    // 外部同期を一時停止してチラつきを防止
    vm.$store.state._suspendExternalSync = true;
    const src = map01?.getSource('click-circle-source');
    if (!src) return;
    let geojson = null;
    if (restorePrev && vm.$store.state.prevGeojson) {
      geojson = JSON.parse(JSON.stringify(vm.$store.state.prevGeojson));
      src.setData(geojson);
    } else {
      geojson = vm.getSourceData(src);
    }
    if (!geojson || !geojson.features) return;

    // マイドローモードの場合、変更されたfeatureをUndoスタックにpush
    if (vm.$store.state.isUsingServerGeojson && prevGeojson && !restorePrev) {
      const prevFeaturesMap = new Map();
      (prevGeojson.features || []).forEach(f => {
        if (f?.properties?.id && f.properties.id !== 'config') {
          prevFeaturesMap.set(String(f.properties.id), f);
        }
      });

      // 変更されたfeatureを検出してUndoスタックにpush
      (geojson.features || []).forEach(f => {
        if (!f?.properties?.id || f.properties.id === 'config') return;
        const featureId = String(f.properties.id);
        const prevFeature = prevFeaturesMap.get(featureId);
        if (prevFeature) {
          // JSON比較で変更があるかチェック
          const prevJson = JSON.stringify(prevFeature);
          const currJson = JSON.stringify(f);
          if (prevJson !== currJson) {
            // 変更されたfeatureをUndoスタックにpush
            pushMyDrawUndoAction('modify', f.properties.id, prevFeature);
          }
        }
      });
    }

    vm.$store.state.clickCircleGeojsonText = JSON.stringify(geojson);
    featureCollectionAdd();
    markerAddAndRemove(true);
    generateStartEndPointsFromGeoJSON(geojson);
    generateSegmentLabelGeoJSON(geojson);
    vm.$store.state._lastLocalEditAt = Date.now();
    vm.$store.state._suspendExternalSync = false;
    // グローバル関数として呼び出す（this 経由ではない）
    // 一時的に editEnabled を下げて保存を許可
    vm.$store.state.editEnabled = false;
    await saveDrowFeatures(geojson.features);
  } catch (e) {
    console.warn('[persistAndExitEditMode] failed', e);
  } finally {
    // 少し待ってから外部同期を再開（ポーリングによるチラつき防止）
    setTimeout(() => {
      vm.$store.state._suspendExternalSync = false;
    }, 500);
    if (wasEditEnabled) {
      // toggleEditEnabled 内のクリーンアップを走らせるため一度 true に戻す
      vm.$store.state.editEnabled = true;
      vm.toggleEditEnabled();
    }
    vm.$store.state.prevGeojson = null;
    vm.$store.state.showDrawConfrim = false;
  }
}
// ---------------------------------------------------------------------
export function startAnglePlus(vm: VM) {
  vm.plusStep = 1
  vm.plusInterval = setInterval(() => {
    vm.plusStep++
    vm.angleValue = vm.angleValue + vm.plusStep
    vm.onRotateInput(vm.angleValue);
  }, 100)
}
export function stopAnglePlus(vm: VM) {
  if (vm.plusInterval) {
    clearInterval(vm.plusInterval)
    vm.plusInterval = null
  }
  vm.plusStep = 1
}
export function startAngleMinus(vm: VM) {
  vm.minusStep = -1
  vm.minusInterval = setInterval(() => {
    vm.minusStep--
    vm.angleValue = vm.angleValue + vm.minusStep
    vm.onRotateInput(vm.angleValue);
  }, 100)
}
export function stopAngleMinus(vm: VM) {
  if (vm.minusInterval) {
    clearInterval(vm.minusInterval)
    vm.minusInterval = null
  }
  vm.minusStep = -1
}
// ─── スライダーや入力ボックス連動用 ───
export function onRotateInput(vm: VM, angle) {
  scaleAndRotateLassoSelected(Number(vm.scaleValue),Number(angle));
}
// ─── 投げ縄変形のリセット ───
export function resetLassoTransform(vm: VM) {
  vm.angleValue = 0;
  vm.scaleValue = 100;
  scaleAndRotateLassoSelected(100, 0);
}
// ─── 投げ縄コントロールを閉じる（確定） ───
export function closeLassoControl(vm: VM) {
  const source = vm.map01.getSource('click-circle-source');
  const geojson = vm.getSourceData(source);
  if (geojson && geojson.features) {
    geojson.features.forEach(f => {
      delete f.properties.lassoSelected;
    });
    vm.s_isLassoSelected = false;
    vm.map01.getSource('click-circle-source').setData(geojson);
    vm.$store.state.clickCircleGeojsonText = JSON.stringify(geojson);
    vm.$store.state.lassoGeojson = JSON.stringify({ type: 'FeatureCollection', features: [] });
    vm.$store.state.updatePermalinkFire = !vm.$store.state.updatePermalinkFire;
  }
  // リセット
  vm.angleValue = 0;
  vm.scaleValue = 100;
  // 連続描画モード時は投げ縄モードを維持（次の選択へ）
  // 非連続時はここで何もしない（投げ縄モード自体は維持されている）
}
// ─── 投げ縄モードを終了（確定） ───
export function exitLassoMode(vm: VM) {
  // Transform Boxを非表示
  hideTransformBox()
  // 選択をクリア
  if (vm.s_isLassoSelected) {
    const source = vm.map01.getSource('click-circle-source');
    const geojson = vm.getSourceData(source);
    if (geojson && geojson.features) {
      geojson.features.forEach(f => {
        delete f.properties.lassoSelected;
      });
      vm.s_isLassoSelected = false;
      vm.map01.getSource('click-circle-source').setData(geojson);
      vm.$store.state.clickCircleGeojsonText = JSON.stringify(geojson);
      vm.$store.state.updatePermalinkFire = !vm.$store.state.updatePermalinkFire;
    }
  }
  // 投げ縄モードをオフ
  vm.s_isDrawLasso = false;
  // 編集モードをオフ
  if (vm.s_editEnabled) {
    vm.toggleEditEnabled();
  }
  // FloatingWindowを閉じる
  vm.$store.commit('setFloatingVisible', { id: 'lasso-control-window', visible: false });
  // バックアップをクリア
  vm.$store.state.lassoBackupGeojson = null;
  // リセット
  vm.angleValue = 0;
  vm.scaleValue = 100;
}
// ─── 投げ縄クローズ確認ダイアログを表示 ───
export function showLassoCloseConfirmDialog(vm: VM) {
  vm.showLassoCloseConfirm = true;
}
// ─── 投げ縄クローズ確認後に実行 ───
export function confirmLassoClose(vm: VM) {
  vm.showLassoCloseConfirm = false;
  vm.cancelLassoMode();
}
// ─── 投げ縄モードをキャンセルして終了 ───
export function cancelLassoMode(vm: VM) {
  // Transform Boxを非表示
  hideTransformBox()
  // 選択中の場合はバックアップから復元
  if (vm.s_isLassoSelected && vm.$store.state.lassoBackupGeojson) {
    const backupGeojson = JSON.parse(vm.$store.state.lassoBackupGeojson);
    vm.map01.getSource('click-circle-source').setData(backupGeojson);
    vm.$store.state.clickCircleGeojsonText = JSON.stringify(backupGeojson);
    vm.$store.state.updatePermalinkFire = !vm.$store.state.updatePermalinkFire;
    // 矢印とラベルを再生成
    generateStartEndPointsFromGeoJSON(backupGeojson);
    // 距離計測ラベルを再生成
    generateSegmentLabelGeoJSON(backupGeojson);
    // featureCollectionを更新してからマーカーを再作成
    setTimeout(() => {
      featureCollectionAdd();
      markerAddAndRemove(true);
    }, 100);
  }
  vm.s_isLassoSelected = false;
  // 投げ縄モードをオフ
  vm.s_isDrawLasso = false;
  // 編集モードをオフ
  if (vm.s_editEnabled) {
    vm.toggleEditEnabled();
  }
  // FloatingWindowを閉じる
  vm.$store.commit('setFloatingVisible', { id: 'lasso-control-window', visible: false });
  // バックアップをクリア
  vm.$store.state.lassoBackupGeojson = null;
  // リセット
  vm.angleValue = 0;
  vm.scaleValue = 100;
}
// ─── 投げ縄の変更を元に戻す（FWは閉じない） ───
export async function restoreLassoChanges(vm: VM) {
  if (!vm.$store.state.lassoBackupGeojson) {
    vm.snackbarText = '元に戻すデータがありません';
    vm.snackbar = true;
    return;
  }
  // 選択されていたフィーチャーのIDリストを取得
  const lassoGeojson = vm.$store.state.lassoGeojson ? JSON.parse(vm.$store.state.lassoGeojson) : null;
  const selectedIds = new Set();
  if (lassoGeojson && lassoGeojson.features) {
    lassoGeojson.features.forEach(f => {
      if (f.properties.id) selectedIds.add(f.properties.id);
    });
  }
  // バックアップから復元
  const backupGeojson = JSON.parse(vm.$store.state.lassoBackupGeojson);
  // 選択状態を再適用（バックアップには選択状態がないため）
  backupGeojson.features.forEach(f => {
    if (selectedIds.has(f.properties.id)) {
      f.properties.lassoSelected = true;
    }
  });
  vm.map01.getSource('click-circle-source').setData(backupGeojson);
  vm.$store.state.clickCircleGeojsonText = JSON.stringify(backupGeojson);
  vm.$store.state.updatePermalinkFire = !vm.$store.state.updatePermalinkFire;
  // 矢印とラベルを再生成
  generateStartEndPointsFromGeoJSON(backupGeojson);
  generateSegmentLabelGeoJSON(backupGeojson);
  // マーカーを更新
  featureCollectionAdd();
  markerAddAndRemove(true);
  // Transform Boxの位置を更新（選択状態を再適用したgeojsonで計算）
  await refreshTransformBox(backupGeojson);
  // スライダーをリセット
  vm.angleValue = 0;
  vm.scaleValue = 100;
  vm.snackbarText = '変更を元に戻しました';
  vm.snackbar = true;
}